export default remote => ({
    categories: (website, params) => remote.get(`content/support/categories/${website}`, {params}),
    questions: (website, params) => remote.get(`content/support/questions/${website}`, {params}),
    search: (website, q) => remote.post(`content/support/search/${website}`, {q})
});
